export function handleDragStart(e: any, index: any, todoItemDrag: any) {
  todoItemDrag.current = index;
}
export function handleDragEnter(e: any, index: any, todoItemDragOver: any) {
  todoItemDragOver.current = index;
}
export function handleDragEnd(
  e: any,
  index: any,
  todoItemDrag: any,
  todoItemDragOver: any,
  optionsObject: any,
  defaultSelected: any,
  scoreValue?: any
) {
  let arr1 = { ...optionsObject };
  let arr2 = { ...defaultSelected };
  let arr3 = { ...scoreValue };

  let objArr1 = Object.entries(arr1);
  let objArr2 = Object.entries(arr2);
  let objArr3 = Object.entries(arr3);

  const dragItemContent1 = objArr1[todoItemDrag.current - 1];
  objArr1.splice(todoItemDrag.current - 1, 1);
  objArr1.splice(todoItemDragOver.current - 1, 0, dragItemContent1);

  const dragItemContent2 = objArr2[todoItemDrag.current - 1];
  objArr2.splice(todoItemDrag.current - 1, 1);
  objArr2.splice(todoItemDragOver.current - 1, 0, dragItemContent2);

  const dragItemContent3 = objArr3[todoItemDrag.current - 1];
  objArr3.splice(todoItemDrag.current - 1, 1);
  objArr3.splice(todoItemDragOver.current - 1, 0, dragItemContent3);

  const newObj = Object.fromEntries(objArr1);
  const newObj2 = Object.fromEntries(objArr2);
  const newObj3 = Object.fromEntries(objArr3);

  let temp = {},
    temp2 = {},
    temp3 = {};
  Object.keys(newObj).map((obj: any, index: any) => {
    temp = { ...temp, [`option${index + 1}`]: newObj[obj] };
  });
  Object.keys(newObj2).map((obj: any, index: any) => {
    temp2 = { ...temp2, [`option${index + 1}`]: newObj2[obj] };
  });

  Object.keys(newObj3).map((obj: any, index: any) => {
    temp3 = { ...temp3, [`option${index + 1}`]: newObj3[obj] };
  });

  todoItemDrag.current = null;
  todoItemDragOver.current = null;

  return { options: temp, defaultOptions: temp2, scoreValue: temp3 };
}
